import {useEffect, useState} from "react";
import useFetch from "use-http";

export const useDataInit = () => {
    const {get, response, loading, error} = useFetch(`${process.env.REACT_APP_API_PATH}`)
    const [dataInit, setDataInit] = useState([])
    const [dataFilterTag, setDataFilterTag] = useState([])
    useEffect( () =>{
        async function fetchData() {
            const fetchedData = await get('/wp/v2/stores?orderby=title&order=asc&per_page=100');
            if (response.ok){
                setDataInit(fetchedData)
                //Add filters
                let deliveriesFilter = [];
                fetchedData.forEach((object, index) => {
                    if (object.sl_hook[1].content) {
                        object.sl_hook[1].content.forEach((subobject, subindex) => {

                            if (deliveriesFilter.findIndex(element => element.label === subobject.title.toLowerCase()) === -1) {
                                deliveriesFilter.push(
                                    {
                                        label: subobject.title.toLowerCase(),
                                        count: 1
                                    }
                                )
                            } else {
                                deliveriesFilter[deliveriesFilter.findIndex(element => element.label === subobject.title.toLowerCase())].count++
                            }
                        })
                    }
                })
                //Add all filters to the state
                setDataFilterTag(deliveriesFilter)
            }


        }
        fetchData().catch()
    },[response.ok])
    return {data : dataInit,filter:dataFilterTag, loading : loading, error : error};
}